import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/home'
    { path: '', pathMatch: 'full', redirectTo: 'home' },

    // Redirect signed-in user to the '/home'
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'home' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        data: {
            layout: 'modern',
        },
        children: [
            {
                path: 'verify-email',
                loadChildren: () =>
                    import('app/modules/auth/verify-email/verify-email.routes'),
            },
            {
                path: 'confirmation-required',
                loadChildren: () =>
                    import(
                        'app/modules/auth/confirmation-required/confirmation-required.routes'
                    ),
            },
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/forgot-password/forgot-password.routes'
                    ),
            },
            {
                path: 'reset-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/reset-password/reset-password.routes'
                    ),
            },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.routes'),
            },
            {
                path: 'sign-up',
                loadChildren: () =>
                    import('app/modules/auth/sign-up/sign-up.routes'),
            },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [],
        canActivateChild: [],
        component: LayoutComponent,
        data: {
            layout: 'modern',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.routes'),
            },
        ],
    },

    // Landing routes
    {
        path: '',
        canActivate: [],
        component: LayoutComponent,
        data: {
            layout: 'modern',
        },
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'home',
                loadChildren: () =>
                    import('app/modules/landing/home/home.routes'),
            },
        ],
    },

    // Admin routes
    {
        path: '',
        canActivate: [],
        canActivateChild: [],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            // {
            //     path: 'programa',
            //     loadChildren: () =>
            //         import('app/modules/admin/programas/programas.routes'),
            // },
            // Flujo de inscripción UNIFICADO (wizard v2, valida por nivel:
            // Licencia B y C con expediente/candado de Servicios Escolares
            // como paso 3; el resto de niveles sin ese paso).
            // - 'programa-formacion': ruta CANÓNICA del flujo nuevo (los
            //   links internos y correos apuntan aquí).
            // - 'programa-formacion-nivel': alias de compatibilidad para
            //   correos/links ya enviados con esa ruta.
            // - 'programa-formacion-v1': el wizard viejo, disponible solo
            //   bajo este path por si hay que regresar a consultarlo.
            {
                path: 'programa-formacion',
                loadChildren: () =>
                    import(
                        'app/modules/admin/programa-formacion/programa-formacion-nivel.routes'
                    ),
            },
            {
                path: 'programa-formacion-nivel',
                loadChildren: () =>
                    import(
                        'app/modules/admin/programa-formacion/programa-formacion-nivel.routes'
                    ),
            },
            {
                path: 'programa-formacion-v1',
                loadChildren: () =>
                    import(
                        'app/modules/admin/programa-formacion/programa-formacion.routes'
                    ),
            },
            // {
            //     path: '404-not-found',
            //     pathMatch: 'full',
            //     loadChildren: () =>
            //         import(
            //             'app/modules/admin/error/error-404/error-404.routes'
            //         ),
            // },
            // { path: '**', redirectTo: '404-not-found' },
        ],
    },

    // Mi Progreso routes
    {
        path: '',
        canActivate: [],
        canActivateChild: [],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'mi-progreso',
                loadChildren: () =>
                    import('app/modules/admin/mi-progreso/mi-progreso.routes'),
            },
        ],
    },

    // Expediente Digital routes
    {
        path: '',
        canActivate: [],
        canActivateChild: [],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'expediente-digital',
                loadChildren: () =>
                    import(
                        'app/modules/admin/expediente-digital/expediente-digital.routes'
                    ),
            },
        ],
    },

    // Historial de Pagos routes
    {
        path: '',
        canActivate: [],
        canActivateChild: [],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'historial-pagos',
                loadChildren: () =>
                    import(
                        'app/modules/admin/historial-pagos/historial-pagos.routes'
                    ),
            },
        ],
    },

    // Verify routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'modern',
        },
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'verify/:identificadorInscripcion',
                loadChildren: () =>
                    import('app/modules/admin/verify/verify.routes'),
            },
        ],
    },

    // Catch all: redirect any unknown route to 'home'
    { path: '**', redirectTo: 'home' },
];
